//const backendDomain = "http://192.168.1.44/sgu_erp_live"
//const backendDomain = "https://ghraisonierp.oakyaitservices.in/api"  // live server
//const backendDomain = "http://192.168.1.254/sguerpv4/api"
//const backendDomain = "https://sguerp.oakyaitservices.in/api"
//const backendDomain = "https://sgufollowup.oakyaitservices.in/api"
//const backendDomain = "https://sgu2025.oakyaitservices.in/api/"


const backendDomain = "https://ghraisonierp.oakyaitservices.com/api"


const SummaryApi = {
    uploadEmployee : {
        url : `${backendDomain}/employee/create.php`,
        method : "post"
    },

    verifyEmployee:{
        url : `${backendDomain}/employee/login.php`,
        method : "post"
    },
    verifyOtp:{
        url : `${backendDomain}/employee/login.php`,
        method : "put"  
    },
    uploadStudent:{      
        url : `${backendDomain}/students/create.php`,
        method : "post"
    },
    updateStudent:{
        url : `${backendDomain}/students/update.php`,   
        method : "post"
    },
    getStudentsByEmployeeID:{
        url : `${backendDomain}/students/retrieve.php`,
        method : "put"
    },
    getAllStudents:{
        url : `${backendDomain}/students/retrieve.php`,
        method : "get"
    },
    getAllEmployees:{
        url : `${backendDomain}/employee/retrieve.php`,
        method : "get"
    },
    getAllConsultants:{
        url : `${backendDomain}/employee/consultant.php`,                
        method : "get"
    },
    changeEmployeePassword:{
        url : `${backendDomain}/employee/update.php`,
        method : "post"
    },
    getEmployeeById:{
        url : `${backendDomain}/employee/retrieve.php`,
        method : "post"
    },
    activateEmployee:{
        url : `${backendDomain}/employee/update.php`,
        method : "put"
    },
    excelUpload:{
        url : `${backendDomain}/student_data/create.php`,
        method : "post"
    },
    verificationDuplicatesData:{
        url : `${backendDomain}/student_data/verify.php`,   
        method : "POST"
    },
    getEmployeeStudentData:{
        url : `${backendDomain}/employee_student_data/retrieve.php`,
        method : "post"
    },
    bulkAction: {
        url : `${backendDomain}/employee/insert.php`,
        method : "post"
    },
    getAllInterestedStudents: {
        url : `${backendDomain}/students/interested.php`,
        method : "get"
    },
    interestedStudents: {
        url : `${backendDomain}/students/interested.php`,
        method : "post"
    },
    notInterestedStudents: {
        url : `${backendDomain}/students/not_interested.php`,
        method : "post"
    },
    getAllNotInterestedStudents: {
        url : `${backendDomain}/students/not_interested.php`,
        method : "get"
    },
    mostInterestedStudents: {
        url : `${backendDomain}/students/most_interested.php`,
        method : "post"
    },
    getAllMostInterestedStudents: {
        url : `${backendDomain}/students/most_interested.php`,
        method : "get"
    },
    callbackStudents: {
        url : `${backendDomain}/students/others.php`,
        method : "post"
    },
    getAllcallbackStudents: {
        url : `${backendDomain}/students/others.php`,
        method : "get"
    },
    employeeReport: {
        url : `${backendDomain}/employee/employee_student.php`,
        method : "get"
    },
    otherscallbackReport: {
        url : `${backendDomain}/employee/employee_student.php`,
        method : "get"
    },
    notansweredReport: {
        url : `${backendDomain}/students/not_answered.php`,
        method : "post"
    },
    getAllnotansweredReport: {
        url : `${backendDomain}/students/not_answered.php`,
        method : "get"
    },

    calllogsstudentcreate: {
        url : `${backendDomain}/student_call_log/create.php`,
        method : "post"
    },
    getcalllogsstudent: {
        url : `${backendDomain}/student_call_log/retrieve.php`,
        method : "get"
    },

dashboardcounts:{
    url : `${backendDomain}/students/dashboard.php`,
    method : "get" 
},

dashboardcountsById:{
    url : `${backendDomain}/students/dashboard.php`,
    method : "post" 
},

todaystudents:{
    url : `${backendDomain}/students/today_students.php`,
    method : "get" 
},

todaystudentsById:{
    url : `${backendDomain}/students/today_students.php`,
    method : "post" 
},

searchstudents:{
    url : `${backendDomain}/students/search.php`,
    method : "post" 
},

searchstudentsById:{
    url : `${backendDomain}/students/search.php`,
    method : "put" 
},

TeamLeadEmp:{
    url : `${backendDomain}/team_lead_emp_assign/emp_assign_retrieve.php`,
    method : "POST" 
},
getEmpDataByTLIdndEmpId:{
    url : `${backendDomain}/team_lead_emp_assign/emp_assign_retrieve.php`,
    method : "PUT" 
},
getAllTL:{
     url : `${backendDomain}/employee/team_leads.php`,
    method : "GET" 
},
getTLEmpCountByTLId:{
     url : `${backendDomain}/team_lead_emp_assign/dashboard.php`,
    method : "POST" 
},
todayenrolledStudentByEmpId:{
    url : `${backendDomain}/team_lead_emp_assign/today_employee_data.php`,
    method : "POST" 
},

getStudentDataByStudentId:{
      url : `${backendDomain}/tl_followups/student_retrieve.php`,
    method : "POST"
},
getTeamLeadPerformance: {
  url: `${backendDomain}/tl_followups/tl_counts.php`,
  method: "POST"
},
createStudentFollowDetails:{
    url : `${backendDomain}/student_follow_ups_details/create.php`,
    method : "POST"
    
},
getStudentFollowDetails:{
      url : `${backendDomain}/student_follow_ups_details/retrieve.php`,
    method : "PUT"
},
updateTlFollowUp:{
    url : `${backendDomain}/tl_followups/update.php`,
    method : "POST"
},
TlRemainders:{
    url : `${backendDomain}/tl_followups/remainder.php`,
    method : "POST"
},
EmpRemainders:{
    url : `${backendDomain}/tl_followups/remainder.php`,
    method : "PUT"
},
getTLTaskCount:{
    url : `${backendDomain}/team_lead_emp_assign/tl_data.php`,
    method : "GET"
},
getCallDuration3min:{
url : `${backendDomain}/students/duration.php`,
    method : "GET"
},
getTodayTlAllEmpData:{
   url : `${backendDomain}/tl_followups/tl_employee_retrieve.php`,
    method : "POST" 
},
getTlFollowupCountByEmpId:{
     url : `${backendDomain}/tl_followups/tl_employee_retrieve.php`,
    method : "PUT"
},
getTlFollowupHistorByEmpIdStudId:{
      url : `${backendDomain}/student_follow_ups_details/employee_retrieve.php`,
    method : "POST"   
},
tlEmpcountStatus:{
    url : `${backendDomain}/tl_followups/tl_counts.php`,
    method : "POST"
},
createNotification:{
 url : `${backendDomain}/notification/notification_create.php`,
    method : "POST"
},
getActiveNotification:{
     url : `${backendDomain}/notification/notification_retrieve.php`,
    method : "GET"
},
notifictionImg:{
 url : `${backendDomain}/notification/images`,
    
},
updateNotification:{
    url : `${backendDomain}/notification/notification_update.php`,
    method : "POST"
},
getAllNotifications:{
       url : `${backendDomain}/notification/notification_admin_retrieve.php`,
    method : "GET"
},
tlEmpStatusCount:{
    url : `${backendDomain}/tl_followups/tl_emp_counts.php`,
    method : "POST"
},
leadClosing:{
    url : `${backendDomain}/closed_leads/closed_lead_create.php`,
    method : "POST"
},
getClosingLead:{
 url : `${backendDomain}/closed_leads/closed_lead_retrieve.php`,
    method : "GET"
},
tlDashboardCountData:{
     url : `${backendDomain}/team_lead_emp_assign/dashboard_count_data.php`,
    method : "POST"
},

//followup dates based on employee id and student id 
followupDatesByEmpIdStudId:{
    url : `${backendDomain}/employee_followups/student_followup_retrieve.php`,
    method : "POST"   },

CreateFollowupByEmployeeId:{
    url : `${backendDomain}/employee_followups/student_followup_create.php`,
    method : "POST"   },

TodayfollowupDatesByEmpIdStudId:{
    url : `${backendDomain}/employee_followups/student_followup_retrieve.php`,
    method : "PUT"   },

TodayfollowupDatesByEmpIdStudId:{
    url : `${backendDomain}/employee_followups/student_followup_retrieve.php`,
    method : "PUT"   },





adminsearchbar:{
    url : `${backendDomain}/students/admin_search.php`,
    method : "POST"   },

admindatepicker:{
    url : `${backendDomain}/students/admin_search.php`,
    method : "PUT"   },





    

}

export default SummaryApi;